
<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table-hover orderList">
            <caption>{{objectGroupName}}</caption>
            <thead>
              <tr>
                <th>Namn</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="objectDescription in objectDescriptions" :key="objectDescription.id">
                <td>{{objectDescription.name}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ObjectDescriptionListByGroup',
  data () {
    return {
      objectDescriptions: []
    }
  },
  props: {
    objectGroupName: '',
    objectGroupId: 0
  },
  watch: {
    objectGroupId: function (newVal, oldVal) {
      this.fetchObjectDescriptions(newVal)
    },
    objectGroupName: function (newVal, oldVal) {
      this.objectGroupName = newVal
    }
  },
  mounted () {
    if (this.$props.objectGroupId !== 0) {
      this.fetchObjectDescriptions(this.$props.objectGroupId)
    }
  },
  methods: {
    fetchObjectDescriptions (objectGroupId) {
      this.$http
        .get('/api/objectdescriptions/objectgroupid/' + objectGroupId)
        .then(response => { this.objectDescriptions = response.data })
        .catch(error => console.log(error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ObjectManagement/ObjectDescriptionListByGroup.vue